function render() {
  return "Empty parent issue";
}

export default render;
